// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h3[data-v-0f99f493]{margin-right:36px}.close-icon-btn[data-v-0f99f493]{position:absolute;top:16px;right:16px}", ""]);
// Exports
module.exports = exports;
